"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledPopover = exports.PopoverGlobalStyle = void 0;
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _PopoverGlobalStyleMixin = require("../../mixins/components/PopoverGlobalStyleMixin");
var _PopoverMixin = require("../../mixins/components/PopoverMixin");
var _Modal = require("../Modal/Modal");
var StyledPopover = /*#__PURE__*/(0, _styledComponents.default)(_Modal.Modal).withConfig({
  displayName: "StyledPopover",
  componentId: "c11n-8-107-0__sc-paejr5-0"
})(["", ""], _PopoverMixin.PopoverMixin);
exports.StyledPopover = StyledPopover;
var PopoverGlobalStyle = /*#__PURE__*/(0, _styledComponents.createGlobalStyle)(["", ""], _PopoverGlobalStyleMixin.PopoverGlobalStyleMixin);
exports.PopoverGlobalStyle = PopoverGlobalStyle;